import React from 'react';
import ReactDOM from 'react-dom';
import { Rnd } from 'react-rnd';
import FontAwesome from 'react-fontawesome';

import { roundNumber, copy } from './functions.js';


class AutoscaleSymbolColorSelectLayer extends React.Component {

    constructor(props) {
        super(props);

        this.handleColorSelect = this.handleColorSelect.bind(this);
    }

    handleColorSelect(e) {
        e.preventDefault();
        this.props.onColorSelect(this.props.color, this.props.contentLayer.symbolPosition);
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    
    render() {
        if (this.props.contentLayer.content === null)
            return null;

        const layerPositionStyle = {
            top: this.props.contentLayer.dimensions.posY.toString() + 'px',
            left: this.props.contentLayer.dimensions.posX.toString()  + 'px'
        }; 

        let layerResize = {
            width: this.props.contentLayer.dimensions.width,
            height: this.props.contentLayer.dimensions.height,
            top: this.props.contentLayer.dimensions.posX,
            left: this.props.contentLayer.dimensions.posY,
        }

        return (
            <div className="preview_layer autoscale_symbol_select">
                <div className="layer_position_wrapper" style={layerPositionStyle}>
                    <div className="layer_resize_wrapper" style={layerResize} onClick={this.handleColorSelect}>
                        
                    </div>
                </div>
            </div>
        );
    }
  }

export default AutoscaleSymbolColorSelectLayer;




// WEBPACK FOOTER //
// ./src/AutoscaleSymbolColorSelectLayer.js